export const ROLES = {
  ADMIN: "superuser",
  COMPANY_HEAD: "Company Head",
  TEAM_HEAD: "Team Head",
  MEMBER: "Member",
  COMPANY_MEMBER: 'Company Member',
  PERSONAL_USER: 'Personal User',
};
